import { Component, OnDestroy } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnDestroy {

  // spinner
  public showSpinner = false;
  spinnerSubscription: Subscription;

  constructor(
    private spinner: SpinnerService
  ) {
    this.spinnerSubscription = this.spinner.spinnerObservable.subscribe(flag => {
      setTimeout(() => {
        this.showSpinner = flag;
      }, 500);
    });
  }

  ngOnDestroy() {
    this.spinnerSubscription.unsubscribe();
  }

}
